import Vue from 'vue'
import VueResource from 'vue-resource'
import md5 from 'blueimp-md5'

Vue.use(VueResource);

export default {
    login(user, success_callback, fail_callback) {
        Vue.http.post('user/login', {
            account: user.account,
            password: user.password,
            // 'g-recaptcha-response': user.code
        }).then(
            (response) => {
                let apiResult = response.data;
                let apiCode = parseInt(apiResult.code);
                if (apiCode === 0) {
                    success_callback(apiResult.result.loginData);
                    window.location.reload();
                } else {
                    fail_callback(apiCode);
                }
            },
            () => {
                fail_callback(-1);
            }
        );
    },
    register(user, success_callback, fail_callback) {
        Vue.http.post('user/create', {
            account: user.account,
            password: user.password,
            // 'g-recaptcha-response': user.code
        }).then(
            (response) => {
                let apiResult = response.data;
                let apiCode = parseInt(apiResult.code);
                if (apiCode === 0) {
                    success_callback(apiResult.result.loginData);
                    window.location.reload();
                } else {
                    fail_callback(apiCode);
                }
            },
            () => {
                fail_callback(-1);
            }
        );
    },
    getEg(uid, callback) {
        Vue.http.get('store/get_eg?uid=' + uid).then(
           (response) => {
                let apiResult =response.data;
                let apiCode = apiResult.code;
                if (apiCode == 0) {
                    callback(apiResult.result);
                }
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/api/user.js